import { Stack } from "@mui/material";
import { m } from "framer-motion";
import { UseFormReturn } from "react-hook-form";
import { FormProvider } from "src/components/hook-form";

// ----------------------------------------------------------------------

type Props = {
	methods: UseFormReturn<{}, any, undefined>;
	onSubmit?: VoidFunction;
	children: any;
};

export const FormWrapper = ({ methods, onSubmit, children }: Props) => {
	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack
				gap={2}
				component={m.div}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.6 }}
			>
				{children}
			</Stack>
		</FormProvider>
	);
};

export default FormWrapper;
